// extracted by mini-css-extract-plugin
export default {"cardIcon":"PreguntasFrecuentesCard_cardIcon__sIEau"};